import { createLazyFileRoute } from "@tanstack/react-router";
import { memo } from "react";

import { ResultSidebar } from "@/features/runs/components/ResultSidebar";

export const Route = createLazyFileRoute(
  "/_auth/_app/runs/$id/worklist/$testId/results/$orderId",
)({
  component: memo(ResultSidebar),
});
